import { useGetEventMetadataQuery } from '../api/resultsApi'
import { EventMetadata } from '../utils/types'

export default function useEventMetadata(athlinksEventId: number) {
  const {
    data = {
      eventStartDateTime: 1538336496000,
    } as unknown as EventMetadata,
    isError,
    isFetching,
  } = useGetEventMetadataQuery(athlinksEventId, {
    skip: !athlinksEventId,
  })

  return {
    data,
    error: isError,
    fetching: isFetching,
  }
}
